import { Icon, IconVariants } from 'core/generic/elements/icons';
import styles from './form-header.module.scss';
type FormHeaderProps = {
    headerTitle: string;
    iconVariant?: IconVariants;
};

export const FormHeader = ({
    headerTitle, iconVariant
}: FormHeaderProps) => {
    return (
        <div className={`display-medium bold ${styles.headerWrapper}`}>
            <span className={`${styles.headerTitle}`}>
                {iconVariant && <Icon variant={iconVariant} />}
                {headerTitle}
            </span>
        </div>
    );
};
